"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Select_1 = __importDefault(require("../../Select"));
var CardSubcategorySelect = function (_a) {
    var options = _a.options, _b = _a.editable, editable = _b === void 0 ? false : _b, other = __rest(_a, ["options", "editable"]);
    var renderNoOptionsMessage = function () {
        return editable
            ? "Create a subcategory by typing a name and hitting enter."
            : 'No options';
    };
    return (react_1.default.createElement(Select_1.default, __assign({ editable: editable, multiselect: true, placeholder: react_1.default.createElement("span", { "data-testid": "subcategories-select" }, "Subcategories"), noOptionsMessage: renderNoOptionsMessage, options: options }, other)));
};
exports.default = CardSubcategorySelect;
//# sourceMappingURL=CardSubcategorySelect.js.map